import { render, staticRenderFns } from "./ProjectAppealText.vue?vue&type=template&id=1f44c55a&scoped=true&"
import script from "./ProjectAppealText.vue?vue&type=script&lang=js&"
export * from "./ProjectAppealText.vue?vue&type=script&lang=js&"
import style0 from "./ProjectAppealText.vue?vue&type=style&index=0&id=1f44c55a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f44c55a",
  null
  
)

export default component.exports